import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {User} from '../services/api.client';
import {SystemService} from '../services/SystemService';
import {SecurityService} from '../services/SecurityService';

/**
 * Route-level guard for the UWDA Pledges page. The UWDA nav link is shown/hidden by
 * SidebarComponent.showUwdaMenu(), whose rule combines the user's role with whether a
 * UWDA fund type exists — so it cannot be expressed as a flat role list like the other
 * admin routes use RoleGuard for.
 *
 * To guarantee the route and the nav can never diverge, both call the SAME predicate:
 * SystemService.canAccessUwdaPledges(). This guard does not add any new access logic.
 */
@Injectable()
export class CanAccessUwdaPledgesGuard {

    private user$: Observable<User>;

    constructor(
        private router: Router,
        private system: SystemService,
        private _securityService: SecurityService) {
        this.user$ = this._securityService.currentUser$;
    }

    canActivate(): Observable<boolean> {
        return this.user$.pipe(
            take(1),
            map((user) => {
                if (user && this.system.canAccessUwdaPledges()) {
                    return true;
                }
                this.router.navigate(['/not-authorized']).then();
                return false;
            }));
    }
}
